import { useFlags } from 'launchdarkly-react-client-sdk';

import defaultFlags from './defaultFlags.json';

export function useFlagsWithFallback() {
  const flags = useFlags();

  return environment.LAUNCHDARKLY_CLIENT_SIDE_ID ? flags : defaultFlags;
}
